import { FACILITIES_TYPES } from "./facilitiesTypes";
import { toArray, toObject } from "helpers/convertToObject";

const {
  LOAD_FACILITIES,
  SET_FACILITIES,
  NEW_FACILITY,
  SET_NEW_FACILITY,
  EDIT_FACILITY,
  SET_EDITED_FACILITY,
  DELETE_FACILITY,
  CLEAR_FACILITIES,
  HANDLE_FACILITIES_INPUTS
} = FACILITIES_TYPES;

const initialState = {
  isLoadingPage: false,
  facilities: [],
  facilitiesMap: {},
  station: null,
  //edit
  isAddMode: false,
  isDeleteMode: false,
  editFacility: null,

  stations: [],
  stationsMap: {},

  config: {
    pageSize: 10,
    page: 0,
    sorted: [],
    filtered: []
  },

  stationsByToken: []
};

export const facilitiesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case HANDLE_FACILITIES_INPUTS:
      return {
        ...state,
        [payload.key]: payload.value
      };
    case LOAD_FACILITIES:
      return {
        ...state,
        isLoadingPage: true
      };

    case SET_FACILITIES:
      return {
        ...state,
        isLoadingPage: false,
        facilities: payload.facilities,
        facilitiesMap: payload.facilitiesMap,
        stations: payload.stations,
        stationsMap: payload.stationsMap
      };

    case EDIT_FACILITY:
      return {
        ...state,
        isAddMode: false,
        isDeleteMode: false,
        editFacility: payload && state.facilitiesMap[payload]
      };

    case NEW_FACILITY:
      return {
        ...state,
        isAddMode: true,
        isDeleteMode: false
      };

    case SET_NEW_FACILITY: {
      const newItem = {
        ...payload,
        station: state.stationsMap[payload.idStation]?.label ?? ""
      };

      const newData = toArray(state.facilitiesMap);
      const newFacilities = [newItem, ...newData];
      const newFacilitiesMap = toObject(newFacilities);

      return {
        ...state,
        facilities: newFacilities,
        facilitiesMap: newFacilitiesMap
      };
    }

    case SET_EDITED_FACILITY: {
      const editedItem = {
        ...payload,
        station: state.stationsMap[payload.idStation]?.label ?? ""
      };
      const newFacilitiesMap = {
        ...state.facilitiesMap,
        [payload.id]: { ...state.facilitiesMap[payload.id], ...editedItem }
      };
      const newData = toArray(newFacilitiesMap);

      return {
        ...state,
        facilitiesMap: newFacilitiesMap,
        facilities: newData
      };
    }

    case DELETE_FACILITY:
      return {
        ...state,
        isAddMode: false,
        isDeleteMode: true
      };

    case CLEAR_FACILITIES:
      return {
        ...state,
        ...initialState
      };

    default:
      return state;
  }
};
